"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageSizeEnum = void 0;
/**
 * Размеры изображений
 */
var ImageSizeEnum;
(function (ImageSizeEnum) {
  /** оригинальный размер */
  ImageSizeEnum["original"] = "original";
  /** Картинка для ботов и браузеров */
  ImageSizeEnum["thumb"] = "thumb";
  /** большое изображение - размер зависит от контента */
  ImageSizeEnum["lg"] = "lg";
  ImageSizeEnum["lgX2"] = "lgX2";
  /** среднее изображение - размер зависит от контента */
  ImageSizeEnum["md"] = "md";
  ImageSizeEnum["mdX2"] = "mdX2";
  /** маленькое изображение - размер зависит от контента */
  ImageSizeEnum["sm"] = "sm";
  ImageSizeEnum["smX2"] = "smX2";
  /** очень маленькое изображение - размер зависит от контента */
  ImageSizeEnum["xs"] = "xs";
  ImageSizeEnum["xsX2"] = "xsX2";
  /** аватарки для конференции */
  ImageSizeEnum["conf"] = "conf";
  ImageSizeEnum["confX2"] = "confX2";
  ImageSizeEnum["confX4"] = "confX4";
  /** широкое - ширина максимально доступная, высота автоматически */
  ImageSizeEnum["wide"] = "wide";
  ImageSizeEnum["wideX2"] = "wideX2";
})(ImageSizeEnum = exports.ImageSizeEnum || (exports.ImageSizeEnum = {}));
